import { createContext } from "react"

export const locationContext = createContext({
  location: { lat: "", lng: "" },
  updateLocation: () => {},
})

export const LocationProvider = locationContext.Provider
export const LocationConsumer = locationContext.Consumer
